// import React from 'react';
// import { KeyRound, Eye, EyeOff, X, Loader2 } from 'lucide-react';

// const SetPasswordModal = ({
//   isOpen,
//   onClose,
//   onSubmit,
//   user,
//   password,
//   setPassword,
//   showPassword,
//   setShowPassword,
//   isSetting
// }) => {
//   if (!isOpen || !user) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
//       <div className="w-full border shadow-2xl sm:max-w-md bg-richblue-950 border-yellow-700/40 rounded-2xl sm:rounded-2xl sm:mb-0 mb-[170px]" onClick={(e) => e.stopPropagation()}>
//         <div className="flex items-center justify-between p-5 border-b border-blue-800/40">
//           <h2 className="flex items-center gap-2 text-lg font-bold text-white">
//             <KeyRound className="w-5 h-5 text-yellow-400" /> Set Password
//           </h2>
//           <button onClick={onClose} className="p-2 transition-colors rounded-lg hover:bg-blue-600/20">
//             <X className="w-5 h-5 text-blue-400" />
//           </button>
//         </div>

//         <div className="p-5 space-y-4">
//           <div className="flex items-center gap-3 px-4 py-3 border bg-richblue-900 border-blue-800/40 rounded-xl">
//             <div className="flex items-center justify-center flex-shrink-0 text-sm font-bold text-white border rounded-full h-9 w-9 bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30">
//               {user.user_name?.charAt(0)}
//             </div>
//             <div>
//               <p className="text-sm font-medium text-white">{user.user_name}</p>
//               <p className="text-xs text-blue-400/60">{user.user_email}</p>
//             </div>
//           </div>

//           <div>
//             <label className="block mb-2 text-sm font-medium text-blue-300">New Password</label>
//             <div className="relative">
//               <input
//                 type={showPassword ? 'text' : 'password'}
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 placeholder="Enter new password"
//                 className="w-full bg-richblue-900 border border-blue-800/60 rounded-lg pl-4 pr-11 py-2.5 text-white placeholder-blue-400/40 focus:outline-none focus:ring-2 focus:ring-yellow-600/60"
//                 autoFocus
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowPassword(prev => !prev)}
//                 className="absolute transition-colors -translate-y-1/2 right-3 top-1/2 text-blue-400/60 hover:text-blue-300"
//               >
//                 {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
//               </button>
//             </div>
//           </div>

//           <div className="flex gap-3">
//             <button
//               type="button"
//               onClick={onClose}
//               className="flex-1 px-4 py-2.5 rounded-lg border border-blue-800/60 text-blue-300 hover:bg-blue-800/20 transition-colors text-sm font-medium"
//             >
//               Cancel
//             </button>
//             <button
//               type="button"
//               onClick={onSubmit}
//               disabled={!password.trim() || isSetting}
//               className="flex-1 px-4 py-2.5 rounded-lg bg-yellow-600 hover:bg-yellow-500 disabled:opacity-50 transition-colors text-white text-sm font-semibold flex items-center justify-center gap-2"
//             >
//               {isSetting ? (
//                 <>
//                   <Loader2 className="w-4 h-4 animate-spin" /> Updating...
//                 </>
//               ) : (
//                 <>
//                   <KeyRound className="w-4 h-4" /> Set Password
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SetPasswordModal;


import React from 'react';
import { KeyRound, Eye, EyeOff, X, Loader2 } from 'lucide-react';

const SetPasswordModal = ({
  isOpen,
  onClose,
  onSubmit,
  user,
  password,
  setPassword,
  showPassword,
  setShowPassword,
  isSetting,
  theme
}) => {
  if (!isOpen || !user) return null;

  const isDark = theme === 'dark';

  // Theme-aware classes
  const bgModal = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgHeader = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgUserCard = isDark ? 'bg-richblue-900' : 'bg-gray-50';
  const bgInput = isDark ? 'bg-richblue-900' : 'bg-white';
  
  const borderColor = isDark ? 'border-yellow-700/40' : 'border-yellow-300';
  const borderLight = isDark ? 'border-blue-800/40' : 'border-gray-200';
  const borderInput = isDark ? 'border-blue-800/60' : 'border-gray-300';
  const borderUserCard = isDark ? 'border-blue-800/40' : 'border-gray-300';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-300' : 'text-gray-700';
  const textMuted = isDark ? 'text-blue-400/60' : 'text-gray-500';
  //const textBlue = isDark ? 'text-blue-300' : 'text-blue-600';
  
  const hoverBg = isDark ? 'hover:bg-blue-600/20' : 'hover:bg-gray-100';
  const buttonCancel = isDark 
    ? 'border-blue-800/60 text-blue-300 hover:bg-blue-800/20'
    : 'border-gray-300 text-gray-700 hover:bg-gray-100';
  const buttonSubmit = isDark
    ? 'bg-yellow-600 hover:bg-yellow-500'
    : 'bg-yellow-500 hover:bg-yellow-600';
  
  const iconColor = isDark ? 'text-yellow-400' : 'text-yellow-600';
  const inputFocus = isDark ? 'focus:ring-yellow-600/60' : 'focus:ring-yellow-500/60';
  const placeholderColor = isDark ? 'placeholder-blue-400/40' : 'placeholder-gray-400';

  return (
    <div className={`fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 ${isDark ? 'bg-black/50' : 'bg-gray-500/30'} backdrop-blur-sm`} onClick={onClose}>
      <div className={`w-full border shadow-2xl sm:max-w-md ${bgModal} ${borderColor} rounded-2xl sm:rounded-2xl sm:mb-0 mb-[170px] transition-colors duration-300`} onClick={(e) => e.stopPropagation()}>
        <div className={`flex items-center justify-between p-5 border-b ${bgHeader} ${borderLight}`}>
          <h2 className={`flex items-center gap-2 text-lg font-bold ${textPrimary}`}>
            <KeyRound className={`w-5 h-5 ${iconColor}`} /> Set Password
          </h2>
          <button onClick={onClose} className={`p-2 transition-colors rounded-lg ${hoverBg}`}>
            <X className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-gray-500'}`} />
          </button>
        </div>

        <div className="p-5 space-y-4">
          <div className={`flex items-center gap-3 px-4 py-3 border ${bgUserCard} ${borderUserCard} rounded-xl transition-colors duration-300`}>
            <div className="flex items-center justify-center flex-shrink-0 text-sm font-bold text-white border rounded-full h-9 w-9 bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30">
              {user.user_name?.charAt(0)}
            </div>
            <div>
              <p className={`text-sm font-medium ${textPrimary}`}>{user.user_name}</p>
              <p className={`text-xs ${textMuted}`}>{user.user_email}</p>
            </div>
          </div>

          <div>
            <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>New Password</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter new password"
                className={`w-full ${bgInput} border ${borderInput} rounded-lg pl-4 pr-11 py-2.5 ${textPrimary} ${placeholderColor} focus:outline-none focus:ring-2 ${inputFocus} transition-colors duration-300`}
                autoFocus
              />
              <button
                type="button"
                onClick={() => setShowPassword(prev => !prev)}
                className={`absolute transition-colors -translate-y-1/2 right-3 top-1/2 ${isDark ? 'text-blue-400/60 hover:text-blue-300' : 'text-gray-400 hover:text-gray-600'}`}
              >
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className={`flex-1 px-4 py-2.5 rounded-lg border ${buttonCancel} transition-colors text-sm font-medium`}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onSubmit}
              disabled={!password.trim() || isSetting}
              className={`flex-1 px-4 py-2.5 rounded-lg ${buttonSubmit} disabled:opacity-50 transition-colors text-white text-sm font-semibold flex items-center justify-center gap-2`}
            >
              {isSetting ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" /> Updating...
                </>
              ) : (
                <>
                  <KeyRound className={`w-4 h-4 ${iconColor}`} /> Set Password
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetPasswordModal;
